package pl.mothdigital.neuronowi.components.sections.navheader

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.forms.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.navigation.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import com.varabyte.kobweb.silk.theme.shapes.*
import kotlinx.browser.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.components.sections.sidemenu.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.navigation.*
import pl.mothdigital.neuronowi.theme.*

val NavHeaderStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(1.cssRem)
}

@Composable
fun NavHeader(
    context: PageContext,
    modifier: Modifier,
) {
    Box(
        modifier = NavHeaderStyle.toModifier().then(modifier),
        contentAlignment = Alignment.CenterStart,
    ) {
        Link(
            path = Screen.Home.route,
            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
            modifier = Modifier.ariaLabel("Powrót do strony głównej")
        ) {
            NavHeaderLogo(modifier = Modifier.align(Alignment.CenterStart))
        }

        Row(
            modifier = Modifier
                .align(Alignment.Center)
                .gap((0.5).cssRem)
                .padding(leftRight = 1.cssRem, top = 1.cssRem)
                .displayIfAtLeast(Breakpoint.MD),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            MenuItems(context)
        }

        Row(
            modifier = Modifier
                .align(Alignment.CenterEnd)
                .gap(value = (0.5).cssRem)
                .padding(leftRight = (0.5).cssRem)
                .displayIfAtLeast(Breakpoint.MD),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            FacebookButton()
            InstagramButton()
        }

        Row(
            modifier = Modifier
                .align(Alignment.CenterEnd)
                .fontSize(1.5.cssRem)
                .gap(1.cssRem)
                .padding(leftRight = 1.cssRem)
                .padding(topBottom = 3.px)
                .displayUntil(Breakpoint.MD),
            verticalAlignment = Alignment.CenterVertically
        ) {
            var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }

            HamburgerButton(onClick = { menuState = SideMenuState.OPEN })

            if (menuState != SideMenuState.CLOSED) {
                SideMenu(
                    context = context,
                    menuState = menuState,
                    close = { menuState = menuState.close() },
                    onAnimationEnd = { if (menuState == SideMenuState.CLOSING) menuState = SideMenuState.CLOSED }
                )
            }
        }
    }
}
